import { createClient } from '@supabase/supabase-js'

const supabase = createClient('https://yfntxkejvhlablxmowkc.supabase.co', 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InlmbnR4a2VqdmhsYWJseG1vd2tjIiwicm9sZSI6ImFub24iLCJpYXQiOjE2NzgxMTM0NzIsImV4cCI6MTk5MzY4OTQ3Mn0.Vrvgnu3jOX_XOmBbWVmTOdyx8esFxXsY-tSU1YK_V7U')
export default function useSupabase() {
    return { supabase };
}